import React from "react";
import OrdersTable from "../components/orders/tables/OrdersTable";
import { useQuery } from "react-query";

const Orders = () => {
  const API_URL = process.env.REACT_APP_API_URL + "/orders";
  const { data, isLoading, error } = useQuery("orders", async () => {
    const response = await fetch(API_URL, {
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${process.env.REACT_APP_API_BEARER_TOKEN}`,
      },
    });
    if (!response.ok) {
      throw new Error(`API request failed with status ${response.status}`);
    }
    const result = await response.json();
    console.log(result, "result");
    return result;
  });

  if (isLoading) {
    return <p>Loading orders...</p>;
  }

  if (error) {
    return <p>Error: {error.message}</p>;
  }

  return (
    <div className="container mx-auto">
      <header className="text-center py-8">
        <OrdersTable orders={data} />
      </header>
    </div>
  );
};

export default Orders;
